import { PropositionButtonSchema } from '@/views/sports/components/PropositionButton/styles/PropositionButton.styles';

export const propositionButtonStyles: PropositionButtonSchema = {
  buttonBase: {
    fontFamily: 'roboto',
    fontSize: '2xs',
    textTransform: 'none',
    lineHeight: '1.125',
    sx: {
      '&:active, &[data-active="true"]': {
        color: 'alpha.700',
        textShadow: 'none',
        border: 'none',
        bg: 'alpha.200',
        boxShadow: '0px 3px 6px 0px #7dc5fb inset',
        _hover: {
          bg: 'alpha.300',
        },
      },
      minW: '3rem',
    },
  },
  buttonBaseSpanProps: {
    fontWeight: 'extrabold',
    fontSize: '2xs',
    overflow: 'hidden',
    pos: 'relative',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    alignSelf: 'center',
  },
  buttonBaseBox: {
    fontSize: 'sm',
    fontWeight: 'black',
  },
  textBase: {
    textAlign: 'center',
    color: 'beta.600',
  },
};
